export default __webpack_public_path__ + "static/media/line-of-kids.0434e5c1.png";